import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Tab, Nav } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { getCompanies } from "../../../store/actions/Companies/companyActions";
import { withRouter } from "../../../App";
import { getLoggedInUser, getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import { SVGICON } from "../../constant/theme";
import { getAllJobs } from "../../../store/actions/Jobs/jobActions";
import AddRequirementJob from "./AddJob";
import RequirementList from "./RequirementList";
import { getCandidates } from "../../../store/actions/Candidates/candidateActions";

const RequirementPlans = ({ token, companies, loggedInUser, jobTypeList, payRateTypes }) => {
  const addRequirementModal = useRef();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllJobs(token));
    dispatch(getCompanies(token));
    dispatch(getCandidates(token));
  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Tab.Container defaultActiveKey={"List"}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="heading mb-0">Requirement</h4>
              <div className="d-flex align-items-center">
                <Nav
                  as="ul"
                  className="nav nav-pills mix-chart-tab user-m-tabe"
                  id="pills-tab"
                >
                  <Nav.Item as="li" className="nav-item" role="presentation">
                    <Nav.Link
                      as="button"
                      className="nav-link"
                      eventKey={"List"}
                    >
                      {SVGICON.List}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Link
                  to
                  className="btn btn-primary btn-sm ms-2"
                  onClick={() => addRequirementModal.current.showAddJobModal()}
                >
                  + Create Line
                </Link>
              </div>
            </div>
            <div className="col-xl-12 active-p">
              <Tab.Content>
                {/* <Tab.Pane eventKey={"Grid"}> <GridTab /> </Tab.Pane> */}
                <Tab.Pane eventKey={"List"}>
                  <RequirementList title="Requirements" />
                </Tab.Pane>
              </Tab.Content>
            </div>
          </Tab.Container>
        </div>
      </div>
      <AddRequirementJob
        ref={addRequirementModal}
        Title="Add Requirement"
        companies={companies}
        token={token}
        loggedInUser={loggedInUser}
        jobTypeList={jobTypeList}
        payRateTypes={payRateTypes}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  console.log("state", state);
  return {
    token: getLoggenInToken(state),
    allJobs: state.jobs.allJobList,
    companies: state.companies.companies,
    loggedInUser: getLoggedInUser(state),
    jobTypeList: state?.dropDownValues?.dropDownValues?.jobType || [],
    payRateTypes: state?.dropDownValues?.dropDownValues?.payRateTypes || [],
  };
};

export default withRouter(connect(mapStateToProps)(RequirementPlans));
